module.exports = __webpack_public_path__ + "img/welcome_bg.7fe87ba2.jpg";